import { getAcquisitionFlow, clearSessionStorageVariablesForAcquisitionFlow, getDataEntryPages, AcquisitionFlow, handlePartnerRedirect } from '../../utils/acquisition-utils';
import { cleanInternalLinkUrl } from '../../utils/cob-utils';
import SessionStorage from '../../utils/SessionStorage';
import { TMitekImage } from './MitekProvider';


export const redirect = (url: string, options?: {error?:string, withoutBackNavigation?: boolean}) => {
    url = cleanInternalLinkUrl(url);
    if (options?.error) {
        url += (window.location.search ? window.location.search + '&': '?') + 'errorCode=' + options.error;
    } else {
        url += window.location.search;
    }
    if (options?.error && getAcquisitionFlow() === AcquisitionFlow.PqOfOne) {
        handlePartnerRedirect(url);
    } else if (options?.withoutBackNavigation) {
        window.location.replace(url);
    } else {
        window.location.assign(url);
    }
};

export const checkForPhoneNumber = async () => {
    const flow = getAcquisitionFlow();
    let tempPhoneNumber = await (SessionStorage.tryGetCipher('appAuthorizedResponse', null));
    tempPhoneNumber = tempPhoneNumber?.ApplicantPhoneNumber;

    if (tempPhoneNumber) {
        return tempPhoneNumber;
    }

    switch (flow) {
        case AcquisitionFlow.PQ:
        case AcquisitionFlow.PqOfOne:
        case AcquisitionFlow.SkipPQ:
        case AcquisitionFlow.PHA:
            tempPhoneNumber = (await SessionStorage.tryGetCipher('prequalFullAppData', null))?.PersonalInformation?.PrimaryPhoneNumber;
            break;
        case AcquisitionFlow.PA: {
            tempPhoneNumber = await SessionStorage.tryGetCipher('preApprovalFullAppData', null);
            tempPhoneNumber = tempPhoneNumber?.Applicant?.PrimaryPhoneNumber?.Number;
            break;
        }
    }

    if (tempPhoneNumber) {
        return tempPhoneNumber;
    }

    return null;
};

export const getApplicantId = async (): Promise<string> => {
    const fromDataExposureApplicantId = SessionStorage.get('ApplicationId');
    if (fromDataExposureApplicantId) {
        return fromDataExposureApplicantId;
    } 
    const fromFullAppResponse = await SessionStorage.getCipher('fullAppResponse');
    if (fromFullAppResponse?.ApplicationId) {
        return fromFullAppResponse.ApplicationId;
    }
    return '';
};

export const replaceWithCustomerNumber = (applicantPhoneNumber: string, s: string, altDisclaimer?: string ): string => {
    if (applicantPhoneNumber)
        return s.replace(
            /XXX-XXX-XXXX/g,
            '(***) ***-' + applicantPhoneNumber.substring(applicantPhoneNumber.length - 4),
        );
    
    if (altDisclaimer) {
        return s.replace(
            /:?\s?(&nbsp;)?(<b>)?XXX-XXX-XXXX(<\/b>)?/g,
            (' ' + altDisclaimer),
        );
    }
    return s;
};

export const clearSessionAndRedirectToDataEntry = (dataEntryUrl?: string, errorCode?: string) => {
    if (!dataEntryUrl) {
        dataEntryUrl = getDataEntryPages()[({
            preQual: 'preQualDataEntryPageUrl',
            skipPQ: 'skipPreQualDataEntryPageUrl',
            preApproved: 'preApprovalDataEntryPageUrl',
            pqOne: 'pqOfOneDataEntryPageUrl',
            partnerHosted: 'partnerHostedDataEntryPageUrl',
        } as const)[getAcquisitionFlow()]];
    }
    clearSessionStorageVariablesForAcquisitionFlow();
    if (errorCode) {
        redirect(dataEntryUrl, { error: errorCode, withoutBackNavigation: true });
    }
};

// Developer Note: 
//   Experian is saying we are sending malformed Base64 image data without specifying what is incorrect.
//   Per Tariq's findings, they may not support the data uri being returned from the MitekSDK.
export const formatBase64ImageDataForSubmission = (imageToSubmit: TMitekImage ): TMitekImage => {
    if (!imageToSubmit) {
        return imageToSubmit;
    }
    
    let toReturn = imageToSubmit;
    // Assuming RFC 4648, stripping data from imageData. For more info see: https://developer.mozilla.org/en-US/docs/Web/URI/Schemes/data

    toReturn = toReturn.split(',')[1];

    if (!toReturn) {
        // There was no data uri to strip
        return imageToSubmit;
    }

    return toReturn as TMitekImage;
};